import loginedApi, { c2mdApinew } from "../apis"

// import { USER_TOKEN } from "../constants/const";
import { convertDateToString } from "../Helpers/dateFunctions";
import { getFromLocalStorage } from "../Helpers/localStorageHelper";
import authHeader from './auth-header';
import { REQUEST_DETAILS,INTERBRANCH_ADMIN_CONSOLIDATED, INTERBRANCH_ADMIN_DASHBOARD, INTERBRANCH_ADMIN_DASHBOARD_SELECTED, INTERBRANCH_ADMIN_DETAILED, INTERBRANCH_ADMIN_DETAILED_SELECTED, INTERBRANCH_ADMIN_UPDATE_BOOKING_FORM } from "./type";
import CryptoJS from "crypto-js";
  var hashcode = CryptoJS.SHA256(process.env.REACT_APP_PREFIX+process.env.REACT_APP_TOKEN+process.env.REACT_APP_SECRETKEY);
  let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
  const publicIp = require("public-ip");
let IP = publicIp.v4();
const { detect } = require("detect-browser");
const browser = detect();

let platform = window.navigator.platform;
let userAgent = window.navigator.userAgent;
  let formatTime = off?.split("GMT")[1].split(" (")[0];
  let result = formatTime?.slice(1);
  if (formatTime.search(/\+/g) != null) {
    formatTime = formatTime.replace(/\+/g, "%2B")
  } else if (formatTime.search(/\-/g) != null) {
    formatTime = formatTime.replace(/\-/g, "%2D")
  }//replace(/\+/g,' ') browserTimeZone: `GMT${formatTime}`
  


  export const FETCH_ADMIN_DASHBOARD_REPORT = (clinicId,offset, filterBy,filterType) => async dispatch => {

    console.log("FETCH_ADMIN_DASHBOARD_REPORT........")
    try {
        const headers = {
          'x-requested-with': 'XMLHttpRequest',
        };

        
   

    let params = {
        token :hashcode.toString(),
        "requestType": "524",
        "version": "2.0",
        "data": {
            "clinicId": clinicId,
            offset:offset,
            filterType:filterType,
            browserTimeZone: `GMT${formatTime}`,
            "Type": "All",
            "filterBy": filterBy,
            "startDate": "26-Dec-2022",
            "endDate": "26-Dec-2022",
            //"offset": _para?.offset ? _para.offset.toString() : "0"
        }
    }

    
    const response = await loginedApi.post("getappointmentrequests",params);
  
    return response.data.data
        // Process the response
        console.log(response);
      } catch (error) {
        // Handle error
        console.error(error);
      }


}









export const bookbyorderId = (orderId) => async dispatch => {
  let params = {
    token :hashcode.toString(),
    "requestType": "525",
    "version": "2.0",
    "data": {
        
      orderId:orderId,
      browserTimeZone: `GMT${formatTime}`,
       
    }
}

const response = await loginedApi.post("appointmentbookbyorderId",params,{ headers: authHeader() });
  
    return response.data.data
}

export const FETCH_PAYMENT_TRANSATIONS = (page) => async dispatch => {
  let params = {
    token :hashcode.toString(),
    "requestType": "525",
    "version": "2.0",
    "data": {
        
      page:page,
      browserTimeZone: `GMT${formatTime}`,
       
    }
}

const response = await loginedApi.post("gettransactions",params,{ headers: authHeader() });
  
    return response.data.data
}


export const FETCH_REQUEST_DASHBOARD_REPORT = (requestId) => async dispatch => {

  console.log("FETCH_REQUEST_DASHBOARD_REPORT........")
  try {
      const headers = {
        'x-requested-with': 'XMLHttpRequest',
      };

      
 

  let params = {
      token :hashcode.toString(),
      "requestType": "524",
      "version": "2.0",
      "data": {
          requestId: requestId,
          browserTimeZone: `GMT${formatTime}`,
          "Type": "All",
          "startDate": "26-Dec-2022",
          "endDate": "26-Dec-2022",
          //"offset": _para?.offset ? _para.offset.toString() : "0"
      }
  }

  
  const response = await loginedApi.post("getrequestdetails",params,{ headers: authHeader() });

  dispatch({
    type: REQUEST_DETAILS,
    payload: response.data.data
});

  return response.data.data
      // Process the response
      console.log(response);
    } catch (error) {
      // Handle error
      console.error(error);
    }


}


export const fetch_doctors_list = (clinicId,specialityId) => async dispatch => {
  let params = {
    token :hashcode.toString(),
    "requestType": "529",
    "version": "2.0",
    "data": {
        "clinicName": clinicId,
        browserTimeZone: `GMT${formatTime}`,
        "Subspeciality":specialityId
        //"offset": _para?.offset ? _para.offset.toString() : "0"
    }
}
const response = await loginedApi.post("getdepartmentdoctorlist",params,{ headers: authHeader() });
  
    return response.data.data
}

export const fetch_doctors_list_bySpeciality = (specialityId,clinicId) => async dispatch => {
  let params = {
    token: hashcode.toString(),
    "requestType": "529",
    "version": "2.0",
    "data": {
        specialityId: specialityId,
        "clinicName": clinicId,
    }
  }
  const response = await loginedApi.post("getdepartmentbyspeciality", params, { headers: authHeader() });
  
  return response.data.data
}

export const acceptrejectrequest = (_para) => async dispatch => {
  let params = {
    token :hashcode.toString(),
    "requestType": "525",
    "version": "2.0",
    "data": {
        "process": _para.process,
        browserTimeZone: `GMT${formatTime}`,
        "appointmentId":_para.appointmentId,
        "UserId":_para.UserId,
        "doctorId":_para.doctorId,
        "alternateDate":_para.alternateDate,
        useragent: userAgent,
        Browser: browser?.name + " " + browser?.version,
        Os: platform,
       
    }
}
if(_para.reason!=undefined)
{
  params.data.reason=_para.reason
}
const response = await loginedApi.post("acceptrejectrequest",params,{ headers: authHeader() });
  
    return response.data.data
}

export const changerequeststatus = (_para) => async dispatch => {
  let params = {
    token :hashcode.toString(),
    "requestType": "525",
    "version": "2.0",
    "data": {
        
        browserTimeZone: `GMT${formatTime}`,
        "requestId":_para.appointmentId,
        "userId":_para.UserId,
        "status":_para.status,
        "reason":_para.reason,
        useragent: userAgent,
        Browser: browser?.name + " " + browser?.version,
        Os: platform,
       
    }
}
if(_para.reason!=undefined)
{
  params.data.reason=_para.reason
}
const response = await loginedApi.post("changerequeststatus",params,{ headers: authHeader() });
  
    return response.data.data
}



export const getupdtappoinment = (_para) => async dispatch => {
  let params = {
    token :hashcode.toString(),
    "requestType": "525",
    "version": "2.0",
    "data": {
        "process": _para.process,
        browserTimeZone: `GMT${formatTime}`,
        "appointmentId":_para.appointmentId, 
        "duration":_para.duration,
        "updatedby":_para.UserId,
        "doctorId":_para.doctorId,
        "appoitmentdate":_para.alternateDate,
        "appoitmenttime":_para.appoitmenttime,
        "timezone":_para.timezone,
        "OS":"Web",
       
    }
}

const response = await loginedApi.post("getupdtappoinment",params,{ headers: authHeader() });
  
    return response.data.data
}
